const hiddenScreenReaderText = {
  width: 0,
  height: 0,
};
export default hiddenScreenReaderText;
